import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { getMySubscription } from "@/lib/subscriptions.functions";
import { useCurrentUser } from "@/hooks/useCurrentUser";

export function useIsPremium() {
  const { isAuthenticated } = useCurrentUser();
  const get = useServerFn(getMySubscription);
  const q = useQuery({
    queryKey: ["my-subscription"],
    queryFn: () => get(),
    enabled: isAuthenticated,
    // Plan status barely changes — keep it warm so every page navigation and
    // every component that asks doesn't trigger a new round-trip.
    staleTime: 10 * 60_000,
    gcTime: 30 * 60_000,
    refetchOnWindowFocus: false,
  });
  const sub = q.data;
  const isPremium =
    !!sub && sub.plan === "premium" && (sub.status === "active" || sub.status === "trialing");
  return { isPremium, subscription: sub ?? null, loading: q.isLoading };
}
